import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { shallow } from 'zustand/shallow';
import { Button, RadioSelectAccountGroup } from '@/components/common';
import { paymentSchema } from '@/utils/validation';
import { BuyCryptoStoreInterface, useBuyCrypto } from '@/store/buyCrypto';
import { PaymentType } from '@/api/common.types';
import styles from './Steps.module.css';
import { SelectPaymentCard } from '../components';
import { StepProps } from './EnterAmount';

export const Payment = ({ step, setStep }: StepProps) => {
  const buyState = useBuyCrypto((state) => state, shallow);
  const { handleSubmit, control } = useForm<Partial<BuyCryptoStoreInterface>>({
    resolver: zodResolver(paymentSchema),
    defaultValues: { typeOfPayment: undefined },
    mode: 'onTouched',
  });

  const onSubmit: SubmitHandler<Partial<BuyCryptoStoreInterface>> = (data) => {
    setStep(step + 1);
    buyState.setData(data);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.formTitleWrapper}>
        <Button
          icon="arrowLeft"
          iconClassName={styles.iconBack}
          variants="subtle"
          size="smallSubtle"
          className={styles.buttonBack}
          onPress={() => setStep(step - 1)}
        />
        <h2 className={styles.formTitle}>Select Payment</h2>
      </div>
      <p className={styles.formDescription}>
        0% Fee. Instant. Up to $50,000. Bank account name must match your RelayPay name.
      </p>
      <Controller
        name="typeOfPayment"
        control={control}
        render={({ field }) => (
          <RadioSelectAccountGroup {...field} className={styles.cards}>
            <SelectPaymentCard type="PayID" value={PaymentType.PAY_ID_IN} />
            <SelectPaymentCard type="Bank Transfer" value={PaymentType.NPP_BANK_TRANSFER} />
            <SelectPaymentCard isDisabled type="Debit Card" value="Debit Card" />
          </RadioSelectAccountGroup>
        )}
      />
    </form>
  );
};
